/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Box, Heading, Text } from "@nordcloud/gnui";

export function NotAssignedView() {
  return (
    <Box>
      <div
        css={{
          maxWidth: "924px",
          margin: "0 auto",
        }}
      >
        <Heading level={4}>
          It appears you are not allowed to view any organization in
          IBM&nbsp;Multicloud&nbsp;Accelerator
        </Heading>
        <Text>
          Please ask your administrator to invite you to
          IBM&nbsp;Multicloud&nbsp;Accelerator. If you believe this is an error,
          please contact customer support at products@nordcloud.com
        </Text>
      </div>
    </Box>
  );
}
